export function CategoryId(id, productType = null, reportingCategoryId = null) {
    this.Id = id;
    this.ProductType = productType;
    this.ReportingCategoryId = reportingCategoryId;
} 